import { buildCatalogUrl } from '@/shared/utils/buildCatalogUrl';
import type { BreadcrumbDropdownItem } from '@/shared/ui/AppBreadcrumbs/model/types/appBreadcrumbs';

export interface CityDropdownSource {
  id: number;
  name: string;
  slug: string;
}

const CITY_DROPDOWN_LIMIT = 15;

export const buildCityDropdownItems = (
  cities: CityDropdownSource[],
  selectedSlug?: string,
): BreadcrumbDropdownItem[] => {
  const items: BreadcrumbDropdownItem[] = cities
    .slice(0, CITY_DROPDOWN_LIMIT)
    .map((city) => ({
      id: city.id,
      name: city.name,
      link: buildCatalogUrl({ segments: ['geo', city.slug] }),
      classMod: city.slug === selectedSlug ? '_selected' : '',
    }));

  return items;
};
